import _ = require("lodash");

export const general: string = "General";

export const findId = /\(([^)]+)\)$/;
export const dateRegex = /^\d{4}\-(0[1-9]|1[012])\-(0[1-9]|[12][0-9]|3[01])$/;

export enum UploadStatus {
  Pending = 1,
  OfflineEdit = 2,
  Downloaded = 3,
  Uploaded = 4,
  InvalidInput = 5,
  ServerError = 6,
  UnexpectedAPIError = 7,
  ClientFetchError = 8,
  PostProcessingStepsError = 9,
}

export enum HyperlinkConstants {
  guidanceHyperlink = "https://live.atlas.ey.com/#document/1146470?pref=20052/9/1007&crumb=11",
}

export enum clientRequestAllStatus {
  Draft = 1,
  PendingResponse = 2,
  Received = 3,
  Accepted = 4,
}

export enum ErrorCodes {
  NoError = 0, // No Error
  AccessTokenGetError = 300, // Error comes when we go to Token Provider to get token to call Universal or hercules api
  UniversalApiNoResponseError = 301, // Error comes when no response from api comes either universal down, not able to reach, we are maintaning seprate because for Hercules USN we got no response and user must be on EY Network
  UniversalApiNoValidDataError = 303, // Error comes when universal api return response data but data is not available for selected engagement
  ApiValidationError = 306, // Error comes when universal api return response data but data is not available for selected engagement
  HerculesApiNoResponseError = 398, // Error comes when response don't comes
  ApiValidationFailedUnauthorize = 403, // Api unauthorization failed.
  ApiValidationErrorBadRequest = 400, // Error comes when any input validation failed for data being passed to api
  ApiValidationErrorPreConditionFailed = 412, // Error comes when validation failed against database for records
  ApiUnhandledException = 500, // Error comes when  api has unhandled exception,
  ApiResourceNotFound = 404, // Api resource is not found, can occur if we give api resource url wrong, server name may be correct but actual api resource not found on server
  ApiFailedWithNoSuccess = 999, // Api resource is not found, can occur if we give api resource url wrong, server name may be correct but actual api resource not found on server
}

export enum HTTPMethods {
  Get = "GET",
  PATCH = "PATCH",
}

export enum Constants {
  RequestTablePrefix = "CR_Tbl_",
  MasterWorkSheetPrefix = "Reference_sheet",
  InstructionSheetName = "Instructions",
  MasterTablePrefix = "CR_Master_Tbl_",
  MarkForUpdateYes = "Yes",
  MarkForUpdateNo = "No",
  NewBoundSheetName = "Input_sheet_",
  InstructionsSheetName = "Instructions",
}

export enum CommonConfiguration {
  dataStartingRowIndex = 3,
}

export enum EntityType {
  NotSelected = 0,
  Document = 1,
  Task = 2,
  AddClientRequest = 3,
  EditClientRequest = 4,
  EditITGC = 5,
  EditControl = 6,
  AddOstTask = 7,
  EditMisstatement = 9,
  EditTimePhase = 8,
  EditDeficiency = 10,
}

export enum CommonColumn {
  BeginningColumn = "A",
  status = 0,
  markUpdateValue = 1,
  NoOfFreezeRows = 2,
}

export enum DocumentColumn {
  UpdatedDocumentNameIndex = 2, // Todo: Hritwike: remove as part of your story
  OriginalDocumentNameIndex = 3,
  fileExt = 4,
  documentId = 6,
  hashValue = 7,
}
export enum TaskColumn {
  UpdatedTaskPrefixIndex = 2,
  UpdatedTaskSuffixIndex = 3,
  UpdatedTaskNameIndex = 4,
  OriginalTaskPrefixIndex = 5,
  OriginalTaskSuffixIndex = 6,
  OriginalTaskNameIndex = 7,
  taskType = 8,
  taskTitleEditable = 9,
  hashValue = 14,
}

export enum AddClientRequest {
  ClientRequestTitle = 2,
  ClientRequestDescription = 3,
  AssignedToGroup = 4,
  AssignedToUser = 5,
  DueDate = 6,
  EYContact = 7,
  Tags = 8,
  Priority = 9,
  TimePhase = 10,
  clientRequestGuid = 11,
  ClientRequestId = 12,
  hashValue = 13,
}

export enum ExcelColorValue {
  Default = "",
  Yellow = "#FFE393",
  Blue = "#3865B9",
  Black = "#3A3A3A",
  GrayColor = "D3D3D3",
  White = "#ffffff",
  Red = "#EB8A87",
  Green = "#A1E29E",
  Grayish = "#747474",
}

export enum CommonConstants {
  Join = "join",
  FilterWithJoin = "filterwithjoin",
  ApiTemplate = "apiTemplate",
}

export const ConfidentialityLevels = {
  0: "Default",
  1: "Low",
  2: "Moderate",
  3: "High",
};

export const ExcelFormatting = {
  passwordProtect: 1,
  passwordUnprotect: 2,
};

export class CellAttributes {
  CellHeader: string;
  CellDisplayIndex: number;
  CellFormat: any;
  DataAttributeName: string;
  getCellData: any;
  CellType: CellType;
  CellRangeName: string = "";
  CellId: string = "";
  IsDocIdValue: boolean = false;
  IsMarkValue: boolean = true;
}

export enum CellType {
  DynamicCell = 1,
  Editable = 2,
  Protected = 3,
}

export const apiUriPathParameters: string[] = ["baseUrl", "engagementId"];

export const CellIndexMapping: string[] = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  "AA",
  "AB",
  "AC",
  "AD",
];

export const dateTimeFormats = [
  {
    // 07/22/2014 06:30:48
    id: 0,
    label: "MM/DD/YYYY HH:mm:ss",
    format: "MM/dd/yyyy HH:mm:ss",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  },
  {
    // 22/07/2014 06:30:48
    id: 1,
    label: "DD/MM/YYYY HH:mm:ss",
    format: "dd/MM/yyyy HH:mm:ss",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  },
  {
    // 2014/07/22 06:30:48
    id: 2,
    label: "YYYY/MM/DD HH:mm:ss",
    format: "yyyy/MM/dd HH:mm:ss",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  },
  {
    id: 3,
    label: "YYYY-MM-DD",
    format: "yyyy-MM-DD",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  },
];

export const statusIdsForClientRequestStatus = {
  draft: [1, 2, 5, 10, 11, 14, 17],
  pendingResponse: [6, 9, 13, 16, 20, 21, 27],
  received: [7, 12, 15, 18, 19],
  accepted: [8, 28],
};

export const screenToRender = {
  EntitySelectLayout: 1,
  ClientRequestStatusSelectLayout: 2,
  EngagementSelectLayout: 3,
  SummaryView: 4,
  InputSheetAlreadyExistsLayout: 5,
};

export enum ClientRequestStatusID {
  Undefined = 0,
  Draft = 1,
  NoClientContact = 2,
  Sent = 3,
  SystemError = 4,
  InvalidClientContact = 5,
  PendingResponse = 6,
  Received = 7,
  Accepted = 8,
  Returned = 9,
  Withdrawn = 10,
  SendInTransit = 11,
  AcceptInTransit = 12,
  WithdrawInTransit = 13,
  DeleteInTransit = 14,
  ReturnInTransit = 15,
  ResponseInTransit = 16,
  Deleted = 17,
  InvalidClientContactReturned = 18,
  RecallInTransit = 19,
  Recalled = 20,
  CompletionInTransit = 21,
  ParentPendingResponse = 24,
  ParentDraft = 22,
  ParentReceived = 25,
  ParentAccepted = 26,
}

export enum ColumnType {
  UploadStatus = "UploadStatus",
  UploadStatusId = "UploadStatusId",
  MarkForUpdate = "MarkForUpdate",
  HashValue = "HashValue",
}

export const SuccessStatusCode = [200, 201, 204];
